import { render, staticRenderFns } from "./editDriverWarningPay.vue?vue&type=template&id=55090560&scoped=true"
import script from "./editDriverWarningPay.vue?vue&type=script&lang=js"
export * from "./editDriverWarningPay.vue?vue&type=script&lang=js"
import style0 from "./editDriverWarningPay.vue?vue&type=style&index=0&id=55090560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55090560",
  null
  
)

export default component.exports